module.exports = __webpack_public_path__ + "img/4.1ab7f796.png";